@let gridData = $gridData();
@let T = gridData.data;
<unity-grid-shared
  gridTitle="Form Templates"
  [gridData]="gridData"
  [gridError]="$gridError()"
  [gridLoading]="$gridLoading()"
  [defaultSort]="defaultSort"
  (dataQueryEvent)="onDataQuery($event)">
  <kendo-grid-column field="form_schema.name" title="Name">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-link-gridcell-shared [displayText]="item.name" [link]="['/agreement', $agreementId(), 'form', item.id]" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="start_date" title="Start Date" filter="date">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      {{ item.start_date | dateTimezone }}
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="type.name" title="Form Type" />
  <kendo-grid-column field="current_state.name" title="Status">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-chip-workflow-state-shared [name]="item.current_state.name" [value]="item.current_state.enum_value" />
    </ng-template>
  </kendo-grid-column>
</unity-grid-shared>
